import { render, staticRenderFns } from "./EmpNewRequest.vue?vue&type=template&id=6230f581&"
import script from "./EmpNewRequest.vue?vue&type=script&lang=js&"
export * from "./EmpNewRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports